import React, { useState, useEffect } from "react";
import {
  Modal,
  Paper,
  Typography,
  TextField,
  IconButton,
  Button,
  Input,
  Grid,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  useTheme,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { toastAlert } from "../../../utils/AlertContext";
import { getAddCartonURL } from "../../../utils/ConstantsURL";

export const AddCarton = ({
  token,
  open,
  close,
  selectedDate,
  selectedIdSection,
  sections,
  idDocument,
  refresh,
}) => {
  const [cartonData, setCartonData] = useState({
    autor: "",
    fecha: "",
    testigo: "",
    seccion_id: "",
    image: null,
  });

  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const validate = () => {
    return (
      !cartonData.autor ||
      !cartonData.fecha ||
      !cartonData.testigo ||
      !cartonData.seccion_id ||
      !cartonData.image
    );
  };

  const handleChange = (field) => (event) => {
    setCartonData({ ...cartonData, [field]: event.target.value });
  };

  const handleImageChange = (event) => {
    setCartonData({ ...cartonData, image: event.target.files[0] });
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("autor", cartonData.autor);
      formDataToSend.append("fecha", cartonData.fecha);
      formDataToSend.append("testigo", cartonData.testigo);
      formDataToSend.append("seccion_id", cartonData.seccion_id);
      formDataToSend.append("id_documento", idDocument);
      formDataToSend.append("image", cartonData.image);

      const response = await fetch(getAddCartonURL(), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      const result = await response.json();

      if (response.ok) {
        toastAlert("Carton agregado correctamente", "success", 3000);
        setLoading(false);
        setCartonData({
          autor: "",
          fecha: "",
          testigo: "",
          seccion_id: "",
          image: null,
        });
        close();
        refresh();
      } else {
        toastAlert("Error al enviar la petición", "error");
        console.log("Error: " + result.message);
        setLoading(false);
      }
    } catch (error) {
      toastAlert("Error al enviar la petición: " + error, "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      setCartonData({
        autor: "",
        fecha: selectedDate || "",
        testigo: "",
        seccion_id: selectedIdSection || "",
        image: null,
      });
    }
  }, [open, selectedDate, selectedIdSection]);

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "70%",
          outline: "none",
        }}
      >
        <Grid container spacing={2} justifyContent="space-between" alignItems="center">
          <Grid item xs={10}>
            <Typography variant="h6">Agregar nuevo carton</Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <IconButton
              onClick={() => {
                setCartonData("");
                close();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: "10px" }}>
          <Grid item xs={12} sm={12} md={6}>
            <TextField
              label="Autor"
              variant="outlined"
              fullWidth
              value={cartonData.autor}
              onChange={handleChange("autor")}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <TextField
              label="Testigo"
              variant="outlined"
              fullWidth
              value={cartonData.testigo}
              onChange={handleChange("testigo")}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <TextField
              label="Fecha"
              variant="outlined"
              type="date"
              value={cartonData.fecha}
              onChange={handleChange("fecha")}
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: selectedDate }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="select-seccion-label">Sección</InputLabel>
              <Select
                labelId="select-seccion-label"
                value={cartonData.seccion_id}
                onChange={handleChange("seccion_id")}
                label="Sección"
              >
                {sections.map((item) => (
                  <MenuItem key={item.ID_SECCION} value={item.ID_SECCION}>
                    {item.NOMBRE_SECCION}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <Input
              accept="image/*"
              type="file"
              id="upload-file"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
            <label htmlFor="upload-file">
              <Button
                variant="outlined"
                component="span"
                color="primary"
                fullWidth
                style={{
                  borderColor: "#8e8d89",
                  padding: "14px",
                  color: theme.palette.mode === 'dark' ? "#fff" : "black",
                }}
              >
                {cartonData.image ? cartonData.image.name : "Subir imagen"}
              </Button>
            </label>
          </Grid>
        </Grid>

        <Grid container justifyContent="flex-end" style={{ marginTop: "20px" }}>
          <Grid item>
            <LoadingButton
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              loading={loading}
              disabled={validate()}
            >
              Agregar
            </LoadingButton>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
};
